import {scroll} from './scroll';
let selectors = [];
export const matchHeight = (..._selectors) => {
    selectors = _selectors;


}

export const applyMatchHeight = () => {
    selectors.forEach((selector) => {
        applyMatchHeightBySelector(selector);
    });
}

const applyMatchHeightBySelector = (selector) => {

    const elements = document.querySelectorAll(selector);

  // reset height
    elements.forEach(el => el.style.height = 'auto');

    if (elements.length > 0) {
        let lastBottom = parseInt(elements[0].getBoundingClientRect().bottom);
        let line = 0;
        let elementGroupByLine = [[]];

      /*
      * Group element by line based on their top
      */
        elements.forEach(el => {
            const elParentBottom = parseInt(el.parentNode.getBoundingClientRect().top);
            if (lastBottom !== elParentBottom) {
                line++;
                elementGroupByLine[line] = [];
            }
            elementGroupByLine[line].push(el);
            lastBottom = elParentBottom;
        });

          /*
          * Loop in each group to match element height (only if there is more than 1 element)
          */
        elementGroupByLine.forEach(group => {
            let maxHeight = 0;
            if (group.length > 1) {
                group.forEach(el => {
                    const elHeight = el.getBoundingClientRect().height;

                    if (maxHeight < elHeight) {
                        maxHeight = elHeight;
                    }
                });
                if (maxHeight > 0) {
                        group.forEach(el => el.style.setProperty('height',`${maxHeight}px`));
                }
            }
        });
    }
}
